import React, { useState, useEffect } from "react";

import { Box, Button, Checkbox, Chip, FormControlLabel, Icons, Typography } from '@curves/ui-base';

import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { ageRangeMap } from "@Local/Grades/Components/gradesDataLoader";
const AgeRangeSelector = ({ selectedAges, onAgeChange }) => {
	const [open, setOpen] = useState(false);
	const [tempSelectedAges, setTempSelectedAges] = useState(selectedAges);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
		setTempSelectedAges(selectedAges); // 重置為原始選擇
	};
	const handleConfirm = () => {
		onAgeChange(tempSelectedAges);
		setOpen(false);
	};
	const handleAgeToggle = (ageKey) => {
		setTempSelectedAges(prev => {
			if (prev.includes(ageKey)) {
				return prev.filter(age => age !== ageKey);
			} else {
				return [...prev, ageKey];
			}
		});
	};
	const handleSelectAll = () => {
		if (tempSelectedAges.length === ageRangeMap.length) {
			setTempSelectedAges([]);
		} else {
			setTempSelectedAges(ageRangeMap.map(range => range.key));
		}
	};
	const getSelectedAgeNames = () => {
		if (selectedAges.length === 0) return "請選擇年齡範圍";
		if (selectedAges.length === 1) {
			const ageRange = ageRangeMap.find(a => a.key === selectedAges[0]);
			return ageRange ? ageRange.labsel : "未知年齡範圍";
		}
		return `已選擇 ${selectedAges.length} 個年齡範圍`;
	};
    useEffect(() => {
		setTempSelectedAges(selectedAges);
	}, [selectedAges]);
	return (
		<Box>
			<Typography variant="h6" className="mb-3">
				年齡範圍
			</Typography>
			<Button
				variant="outlined"
				onClick={handleOpen}
				fullWidth
			 color="primary">
                <Icons.Plus color="primary" />
				<span>{getSelectedAgeNames()}</span>
			</Button>
			{selectedAges.length > 0 && (
				<Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
					{selectedAges.slice(0, 3).map(ageKey => {
						const ageRange = ageRangeMap.find(a => a.key === ageKey);
						return (
							<Chip
								key={ageKey}
								label={ageRange ? ageRange.label : `年齡${ageKey}`}
								size="small"
								onDelete={() => handleAgeToggle(ageKey)}
							/>
						);
					})}
					{selectedAges.length > 3 && (
						<Chip
							label={`+${selectedAges.length - 3} 個`}
							size="small"
							variant="outlined"
						/>
					)}
				</Box>
			)}
			<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
				<DialogTitle>
					{/* 選擇年齡範圍 */}
					<Box>
						<Button size="small" onClick={handleSelectAll} color="primary">
							{tempSelectedAges.length === ageRangeMap.length ? "清除" : "全選"}
						</Button>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Box>
						{ageRangeMap.map(ageRange => (
							<FormControlLabel
								key={ageRange.key}
								control={
									<Checkbox
										checked={tempSelectedAges.includes(ageRange.key)}
										onChange={() => handleAgeToggle(ageRange.key)}
									/>
								}
								label={ageRange.label}
							/>
						))}
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">取消</Button>
					<Button onClick={handleConfirm} variant="contained" color="primary">
						確認
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};
export default AgeRangeSelector;
